// taken from here: https://stackoverflow.com/a/20762713
export default function getMostFrequent (arr) {
  return arr
    .slice()
    .sort((a, b) => (
      arr.filter(v => v === a).length - arr.filter(v => v === b).length
    ))
    .pop()
}
